import React from 'react';
import { intlShape, injectIntl } from 'react-intl';
import randomstring from 'uuid/v4';

import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import TextField from '@material-ui/core/TextField';

import Snackbar from '../../../labels/Snackbar';
import BlueButton from '../../../buttons/BlueButton';

class MenuValue extends React.Component {
   
    state = {
        report_employee: undefined,
        employee: '',
        from: '',
        to: '',
        employees: []
    }

    componentDidMount(){
        this.props.loadEmployees();
    }

    static getDerivedStateFromProps(props, state) {
        const { report_employee, employees, info } = props;
        if (report_employee !== state.report_employee || info !== state.info || employees !== state.employees) {
            state.report_employee = report_employee;
            state.employee = report_employee ? report_employee.employee : undefined;
            state.from = report_employee && report_employee.from ? report_employee.from : '';
            state.to = report_employee && report_employee.to ? report_employee.to : '';
            state.info = info;
            state.employees = employees ? employees : [];
            return state;
        }
        return null;
    }

    handleScroll = (e) => {
        this.props.setProminentToolBar(e.currentTarget.scrollTop === 0);
    };

    handleSearch = (event) => {
        const { employee, from, to } = this.state;
        if (employee && from && to) {
            this.props
                .loadEmployee(employee, from, to)
                .then(() => this.props.history.push('/reports/employee/resumen'))
                .catch((error) => {
                    this.setState({ error: error.message, errorType: error.type });
                });
        }
    };

    handleChange = (event) => {
        this.setState({ [event.target.name]: event.target.value });
    };

    handleCloseError = () => {
        this.setState({ error: '' });
    };

    render() {
        const { employee, from, to, employees, error, errorType } = this.state;
        const { intl } = this.props;
        return (
            <div className={'flex_full_column padding_bottom_9 height100 center'}>
                <div className="width50 padding_borders_flat">
                    <div className="flex_full_row align_center margin_bottom_12">
                        <FormControl className={'flex_full width100 barlow_italic c_slate'}>
                            <InputLabel htmlFor="age-native-simple">
                                {intl.formatMessage({ id: 'employee' })}
                            </InputLabel>
                            <Select
                                native
                                value={employee}
                                onChange={this.handleChange}
                                inputProps={{ name: 'employee', id: 'employee-id' }}
                            >
                                <option key={randomstring()} value={undefined} />
                                {employees &&
                                    employees
                                        .sort((a, b) =>
                                            a.nombre.toUpperCase().trim() + ' ' + a.apellidos.toUpperCase() <
                                            b.nombre.toUpperCase().trim() + ' ' + b.apellidos.toUpperCase()
                                                ? -1
                                                : 1,
                                        )
                                        .map((a) => {
                                            return (
                                                <option key={randomstring()} value={a.id}>
                                                    {a.nombre.toUpperCase().trim() + ' ' + a.apellidos.toUpperCase()}
                                                </option>
                                            );
                                        })}
                            </Select>
                        </FormControl>
                    </div>
                    <div className="flex_full_row align_center margin_bottom_12">
                        <TextField
                            fullWidth
                            name={'from'}
                            id={'from-date'}
                            label={intl.formatMessage({ id: 'communication_date_from' })}
                            type="date"
                            value={from}
                            onChange={this.handleChange}
                            InputLabelProps={{ shrink: true }}
                        />
                    </div>
                    <div className="flex_full_row align_center margin_bottom_12">
                        <TextField
                            fullWidth
                            name={'to'}
                            id={'to-date'}
                            label={intl.formatMessage({ id: 'communication_date_to' })}
                            type="date"
                            value={to}
                            onChange={this.handleChange}
                            InputLabelProps={{ shrink: true }}
                        />
                    </div>

                    <BlueButton noValid={!employee || !from || !to} id="search" onClick={this.handleSearch} />
                </div>
                {error && (
                    <Snackbar
                        open={true}
                        variant={errorType ?  errorType : "error"}
                        text={error}
                        onClose={this.handleCloseError.bind(this)}
                    />
                )}
            </div>
        );
    }
}

MenuValue.propTypes = {
    intl: intlShape.isRequired,
};

export default injectIntl(MenuValue);



// WEBPACK FOOTER //
// ./src/components/complex/reports/employee/Menu.js